import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { observable, toJS } from 'mobx';
import FetchView from '../../dumb/FetchView/FetchView';
import { Table, TableCell, TableHead, TableBody, TableRow, MenuItem, TextField, CircularProgress, Switch, FormControlLabel, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Select, Tooltip, ButtonGroup, Menu, MenuItem as MuiMenuItem, List } from '@material-ui/core';
import { Container, Button } from 'react-bulma-components';
import NavigationBar from '../NavigationBar/NavigationBar';
import ListingsStore from 'stores/AccountsOverview/ListingsStore';
import DeleteIcon from '@material-ui/icons/Delete';
import RevertIcon from '@material-ui/icons/Undo';
import ConfirmIcon from '@material-ui/icons/Check';
import { toast } from 'react-toastify';
import {CsvBuilder} from 'filefy';
import moment from 'moment';

@observer
class Listings extends Component {
    @observable accessor localstate = {
        selectedAccount: '',
        wkz: '',
        listingsFetch: false,
        saveFetch: false,
        includeDelisted: false,
        originalListings: new Map(),
        changedListings: new Map(),
        addListingAnchorEl: null,
        newListing: { sku: '' },
        isPotential: false,
        confirmRevokeDialogOpen: false,
        revokeListing: null,
        confirmConvertDialogOpen: false,
        convertListing: null,
        deleteDialogOpen: false,
        listingToDelete: null,
    };

    handleAccountChange = async (event) => {
        const accountId = event.target.value;
        this.localstate.selectedAccount = accountId;
        this.localstate.wkz = ListingsStore.list.find(account => account.id === accountId).wkz;
        this.localstate.listingsFetch = true;
        await ListingsStore.fetchListingsByAccountId(accountId);
        this.localstate.listingsFetch = false;
        this.localstate.changedListings.clear();
        this.localstate.originalListings = new Map(ListingsStore.listings.map(listing => [listing.id, { ...listing }]));
        this.localstate.includeDelisted = false;
        this.localstate.newListing = { sku: '' };
    };

    handleSwitchChange = (event) => {
        this.localstate.includeDelisted = event.target.checked;
    };

    handleDeleteClick = (listing) => {
        this.localstate.listingToDelete = listing;
        this.localstate.deleteDialogOpen = true;
    };

    handleFieldChange = (listing, field, value) => {
        if (field === 'listing_date' || field === 'delisting_date') {
            listing[field] = value ? value.toISOString().split('T')[0] : null;
        } else {
            listing[field] = value !== '' ? value : null;
        }
        this.localstate.changedListings.set(listing.id, listing);
    };

    handleAddListingExtend = (event) => { //unfolds the add listing menu
        this.localstate.addListingAnchorEl = event.currentTarget;
    };

    handleAddListingClose = () => {
        this.localstate.addListingAnchorEl = null;
    };

    handleAddListing = (isPotential) => {
        const newSku = this.localstate.newListing.sku;

        const existingListing = ListingsStore.listings.find(listing => listing.sku === newSku);
        if (existingListing && !existingListing.soft_deleted) {
            if (existingListing.status === 'WAITING FOR QM APPROVAL' && !isPotential) {
                this.localstate.convertListing = existingListing;
                this.localstate.confirmConvertDialogOpen = true;
            } else {
                toast.error(`A listing for the provided SKU "${newSku}" already exists.`);
            }
            return;
        }
        const productMatch = ListingsStore.products.find(product => product.att_sku.toUpperCase() === newSku);
        if (!productMatch) {
            toast.error(`The provided SKU "${newSku}" does not exist.`);
            return;
        }
        if (existingListing && existingListing.soft_deleted) {
            this.localstate.isPotential = isPotential;
            this.localstate.revokeListing = existingListing;
            this.localstate.confirmRevokeDialogOpen = true;
        } else {
            const newListing = { sku: newSku, akeneo_product_name: productMatch.product_name, status: isPotential ? 'WAITING FOR QM APPROVAL' : 'LISTED' };
            ListingsStore.listings.push(newListing);
        }
        this.localstate.addListingAnchorEl = null;
        this.localstate.newListing = { sku: '' };
    };

    handleConfirmConvertClose = () => {
        this.localstate.confirmConvertDialogOpen = false;
        this.localstate.convertListing = null;
    };

    handleConfirmConvert = () => {
        const { convertListing } = this.localstate;
        this.handleFieldChange(convertListing, 'status', 'LISTED');
        this.handleConfirmConvertClose();
    };

    handleConfirmRevokeClose = () => {
        this.localstate.confirmRevokeDialogOpen = false;
        this.localstate.revokeListing = null;
    };

    handleConfirmRevoke = async (createNew = false) => {
        const { revokeListing, isPotential } = this.localstate;
        revokeListing.soft_deleted = false;
        if (createNew) {
            Object.keys(revokeListing).forEach(key => {
                if (edit_cols.map(x => col_mapper[x]).includes(key)) {
                    revokeListing[key] = null;
                }
            });
        }
        revokeListing.status = isPotential ? 'WAITING FOR QM APPROVAL' : 'LISTED';
        this.localstate.changedListings.set(revokeListing.id, revokeListing);
        this.localstate.isPotential = false;
        this.localstate.newListing = { sku: '' };
        this.handleConfirmRevokeClose();
    };

    handleRevertChange = (listingId, sku) => {
        if (listingId) {
            const originalListing = this.localstate.originalListings.get(listingId);
            if (originalListing) {
                const listingIndex = ListingsStore.listings.findIndex(listing => listing.id === listingId);
                if (listingIndex !== -1) {
                    ListingsStore.listings[listingIndex] = { ...originalListing };
                }
                this.localstate.changedListings.delete(listingId);
            }
        } else {
            // Remove new added listing by SKU
            ListingsStore.listings = ListingsStore.listings.filter(listing => listing.sku !== sku);
        }
    };

    handleRevertAllChanges = () => {
        // Remove new added listings
        ListingsStore.listings = ListingsStore.listings.filter(listing => listing.id);

        // Revert changes to original listings
        ListingsStore.listings = ListingsStore.listings.map(listing => {
            const originalListing = this.localstate.originalListings.get(listing.id);
            return originalListing ? { ...originalListing } : listing;
        });
        this.localstate.changedListings.clear();
    };

    handleSave = async () => {
        const changedListings = Array.from(this.localstate.changedListings.values());
        const newAddedListings = ListingsStore.listings.filter(listing => !listing.id);
        const allListingsToSave = [...new Set([...changedListings, ...newAddedListings])];

        if (allListingsToSave.length > 0) {
            this.localstate.saveFetch = true;
            await ListingsStore.saveListings(this.localstate.selectedAccount, allListingsToSave);
            this.localstate.saveFetch = false;
            this.localstate.changedListings.clear();
            this.localstate.originalListings = new Map(ListingsStore.listings.map(listing => [listing.id, { ...listing }]));
        } else {
            toast.info('No changes to save.');
        }
    };

    handleDeleteConfirm = async () => {
        const { listingToDelete } = this.localstate;
        const success = await ListingsStore.deleteListing(listingToDelete.id);
        if (success) {
            // Set soft_deleted to true in originalListings map
            const originalListing = this.localstate.originalListings.get(listingToDelete.id);
            if (originalListing) {
                originalListing.soft_deleted = true;
            }

            // Remove the item from changedListings list if included
            this.localstate.changedListings.delete(listingToDelete.id);
        }
        this.localstate.deleteDialogOpen = false;
        this.localstate.listingToDelete = null;
    };

    handleDeleteCancel = () => {
        this.localstate.deleteDialogOpen = false;
        this.localstate.listingToDelete = null;
    };

    renderTableCell = (item, key) => {
        const value = !!item[key] ? item[key] : '';
        if (key === 'uvp' || key === 'vk') {
            return (
                <TextField
                    type="number"
                    value={value}
                    onChange={(e) => this.handleFieldChange(item, key, parseFloat(e.target.value))}
                    InputProps={{
                        endAdornment: <span>€</span>,
                    }}
                />
            );
        } else if (key === 'pos' || key === 'shelf_life') {
            return (
                <TextField
                    type="number"
                    value={value}
                    onChange={(e) => this.handleFieldChange(item, key, parseInt(e.target.value))}
                />
            );
        } else if (key === 'tray') {
            return (
                <TextField
                    value={value.toUpperCase()}
                    onChange={(e) => this.handleFieldChange(item, key, e.target.value)}
                />
            );
        } else if (key === 'listing_date' || key === 'delisting_date') {
            return (
                <TextField
                    type="date"
                    value={value}
                    onChange={(e) => this.handleFieldChange(item, key, e.target.valueAsDate)}
                />
            );
        } else if (key === 'bc_ek') {
            return value ? Number(value).toFixed(2) + '€' : '';
        } else if (key === 'tray_vk') {
            return item['tray'] && item['tray'].match(/_T\d+/g) ? (item['vk'] * item['tray'].split('_T')[1]).toFixed(2) + '€' : ''; //include regex check
        } else if (key === 'wkz') {
            return (
                <TextField
                    type="number"
                    value={value || this.localstate.wkz}
                    onChange={(e) => this.handleFieldChange(item, key, parseFloat(e.target.value))}
                    InputProps={{
                        endAdornment: <span>%</span>,
                    }}
                />
            );
        } else if (key === 'bc_tax') {
            return value ? value + '%' : '';
        } else if (key === 'margin_retail') {
          return item['vk'] && item['uvp'] ? (((item['uvp'] - item['vk']) / item['uvp']) * 100).toFixed(2) + '%' : ''
        } else if (key === 'margin_koro') {
          return item['vk'] && item['bc_ek'] ? (((item['vk'] - item['bc_ek']) / item['vk']) * 100).toFixed(2) + '%' : ''
        } else {
            return value;
        }
    };

    renderStickyTableCell = (item, key, index) => {
        const value = !!item[key] ? item[key] : '';
        return (
            <TableCell
                key={index}
                style={{
                    position: 'sticky',
                    left: index * 150,
                    background: '#fff',
                    zIndex: 2,
                    minWidth: '150px',
                    maxWidth: '150px',
                    padding: '6px 12px',
                    textAlign: 'center',
                    borderRight: index === sticky_cols.length - 1 ? '1px solid #ddd' : 'none',
                }}
            >
                {key === 'status' ? (
                    <Select
                        value={value}
                        onChange={(e) => this.handleFieldChange(item, key, e.target.value)}
                    >
                        <MenuItem value="LISTED">LISTED</MenuItem>
                        <MenuItem value="DELISTED">DELISTED</MenuItem>
                        <MenuItem value="WAITING FOR QM APPROVAL">WAITING FOR QM APPROVAL</MenuItem>
                    </Select>
                ) : (
                    value
                )}
            </TableCell>
        );
    };

    export = () => {
        const includeDelisted = this.localstate.includeDelisted;
        const filtered = ListingsStore?.listings?.filter(listing => !listing.soft_deleted && (includeDelisted || listing.status !== 'DELISTED'))
        const csvBuilder = new CsvBuilder(`product-listings_${moment().format('DDMMYYYY')}.csv`)
        .setColumns([
            'Status',
            'SKU',
            'Product Name',
            'Listing Date',
            'Delisting Date',
            'EK',
            'Margin KoRo',
            'UVP',
            'Maring Retail',
            'VK',
            'POS',
            'Tray SKU',
            'Tray VK',
            'Tax',
            'Category',
            'RLZ',
        ]);

        for (const item of filtered) {
            const {status, sku, akeneo_product_name, listing_date, delisting_date, bc_ek, wkz, uvp, vk, pos, tray, bc_tax, akeneo_product_category, shelf_life } = item;
            const marginKoro = vk && bc_ek ? (((vk - bc_ek) / vk) * 100).toFixed(2) + '%' : '';
            const marginRetail = vk && uvp ? (((uvp - vk) / uvp) * 100).toFixed(2) + '%' : '';
            const trayVK = bc_ek && tray && tray.match(/_T\d+/g) ? (vk * tray.split('_T')[1]).toFixed(2) + '€' : '';
            csvBuilder.addRow([
                status || '',
                sku || '',
                akeneo_product_name || '',
                listing_date || '',
                delisting_date || '',
                bc_ek || '',
                wkz || '',
                marginKoro || '',
                uvp || '',
                marginRetail || '',
                vk || '',
                pos || '',
                tray || '',
                trayVK || '',
                bc_tax || '',
                akeneo_product_category || '',
                shelf_life || '',
            ]);
        }

        csvBuilder.exportFile();
    };

    sortAccountList = (accountList) => {
      if (!accountList) {
        return null;
      }

      return accountList.slice().sort((a, b) => {
        const billNameA = a.bc_bill_name.toLowerCase();
        const billNameB = b.bc_bill_name.toLowerCase();

        if (billNameA < billNameB) {
          return -1;
        }
        if (billNameA > billNameB) {
          return 1;
        }

        return 0;
      });
    };

    render() {
        const { selectedAccount, listingsFetch, saveFetch, includeDelisted, deleteDialogOpen, newListing, addListingAnchorEl, confirmRevokeDialogOpen, confirmConvertDialogOpen, convertListing, originalListings } = this.localstate;

        return (
            <>
                <NavigationBar title="Listings" />
                <Container style={{ marginTop: '20px', overflowX: 'auto', maxWidth: '90%', paddingBottom: '30px' }}>
                    <FetchView stores={[ListingsStore]}>
                        <TextField
                            select
                            label="Select Account"
                            value={selectedAccount}
                            onChange={this.handleAccountChange}
                            fullWidth
                            style={{ marginBottom: '20px' }}
                        >
                            {this.sortAccountList(ListingsStore?.list).map((account) => (
                                <MenuItem key={account.id} value={account.id}>
                                    {account.bc_bill_name}
                                </MenuItem>
                            ))}
                        </TextField>

                        {listingsFetch ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            selectedAccount && (
                                <Container style={{ marginTop: '20px', overflowX: 'auto', maxWidth: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                        <TextField
                                            label="Enter SKU"
                                            value={newListing.sku}
                                            onChange={(e) => this.localstate.newListing.sku = e.target.value.toUpperCase()}
                                            style={{ marginRight: '10px', flex: 1 }}
                                        />
                                        <ButtonGroup size="10px">
                                            <Button onClick={() => this.handleAddListing(true)}>Add Listing</Button>
                                            <Button
                                                aria-controls="add-listing-menu"
                                                aria-haspopup="true"
                                                onClick={this.handleAddListingExtend}
                                            >
                                                ▼
                                            </Button>
                                        </ButtonGroup>
                                        <Menu
                                            id="add-listing-menu"
                                            anchorEl={addListingAnchorEl}
                                            keepMounted
                                            open={Boolean(addListingAnchorEl)}
                                            onClose={this.handleAddListingClose}
                                        >

                                            <MuiMenuItem onClick={() => this.handleAddListing(true)}>Add Potential Listing</MuiMenuItem>
                                            <MuiMenuItem onClick={() => this.handleAddListing(false)}>Add Closed Listing</MuiMenuItem>
                                        </Menu>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={includeDelisted}
                                                    onChange={this.handleSwitchChange}
                                                    name="includeDelisted"
                                                    color="primary"
                                                />
                                            }
                                            label="Include Delisted Listings"
                                        />
                                    </div>
                                    <div>
                                        <Button onClick={this.export}>CSV export</Button>
                                    </div>
                                    <div style={{ overflowX: 'scroll', maxHeight: '50dvh' }}>
                                        <Table aria-label="sticky table" style={{
                                            borderSpacing: '0px',
                                            tableLayout: 'auto',
                                            whiteSpace: 'nowrap',
                                            width: 'max-content',
                                            marginTop: '10px',
                                        }}>
                                            <TableHead>
                                                <TableRow>
                                                    {Object.keys(col_mapper).map((header, index) => (
                                                        <TableCell
                                                            key={index}
                                                            style={{
                                                                padding: '6px 12px',
                                                                fontWeight: 'bold',
                                                                background: '#f9f9f9',
                                                                textAlign: 'center', //check again
                                                                minWidth: sticky_cols.includes(header) ? '150px' : 'auto',
                                                                position: 'sticky',
                                                                left: sticky_cols.includes(header) ? (index * 150) + 'px' : 'auto',
                                                                top: 0,
                                                                zIndex: sticky_cols.includes(header) ? 3 : 2,
                                                            }}
                                                        >
                                                            {header}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell style={{
                                                      padding: '6px 12px',
                                                      fontWeight: 'bold',
                                                      background: '#f9f9f9',
                                                      textAlign: 'center',
                                                      position: 'sticky',
                                                      top: 0,
                                                      zIndex: 2
                                                    }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {ListingsStore?.listings
                                                    ?.filter(listing => !listing.soft_deleted && (includeDelisted || listing.status !== 'DELISTED'))
                                                    ?.sort((a, b) => a.sku < b.sku ? -1 : 1)
                                                    .map((listing, i) => (
                                                        <TableRow key={i} style={!listing.id || originalListings.get(listing.id)?.soft_deleted ? { backgroundColor: '#ffffe0' } : listing.status === 'DELISTED' ? { backgroundColor: '#F5F5F5', fontStyle: 'italic' } : {}}>
                                                            {sticky_cols.map((key, index) => this.renderStickyTableCell(listing, col_mapper[key], index))}
                                                            {Object.keys(col_mapper).slice(sticky_cols.length).map((key, index) => (
                                                                <TableCell
                                                                    key={index}
                                                                    style={{
                                                                        padding: '6px 12px',
                                                                        textAlign: 'center',
                                                                    }}
                                                                >
                                                                    {this.renderTableCell(listing, col_mapper[key])}
                                                                </TableCell>
                                                            ))}
                                                            <TableCell style={{ padding: '6px 12px', textAlign: 'center' }}>
                                                                <Tooltip title="Revert changes">
                                                                    <IconButton
                                                                        color="primary"
                                                                        onClick={() => this.handleRevertChange(listing.id, listing.sku)}
                                                                        style={{ marginLeft: '10px' }}
                                                                    >
                                                                        <RevertIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {listing.id && (
                                                                    <Tooltip title="Delete listing">
                                                                        <IconButton
                                                                            color="secondary"
                                                                            onClick={() => this.handleDeleteClick(listing)}
                                                                        >
                                                                            <DeleteIcon style={{ color: 'red' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                                        <Button onClick={this.handleRevertAllChanges} style={{ marginRight: '10px' }}>Revert all changes</Button>
                                        {saveFetch ? (
                                            <CircularProgress size={24} />
                                        ) : (
                                            <Button color="success" onClick={this.handleSave} disabled={saveFetch}>
                                                Save
                                            </Button>
                                        )}
                                    </div>
                                </Container>
                            )
                        )}
                    </FetchView>
                </Container>

                <Dialog
                    open={deleteDialogOpen}
                    onClose={this.handleDeleteCancel}
                >
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this listing?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleDeleteCancel} color="grey">
                            Cancel
                        </Button>
                        <Button onClick={this.handleDeleteConfirm} color="danger">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={confirmRevokeDialogOpen}
                    onClose={this.handleConfirmRevokeClose}
                >
                    <DialogTitle>Deleted item found</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The SKU "{newListing.sku}" is soft deleted. Do you want to revoke it or create a new listing?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmRevokeClose} color="grey">
                            Cancel
                        </Button>
                        <Button onClick={() => this.handleConfirmRevoke(false)} color="success">
                            Revoke
                        </Button>
                        <Button onClick={() => this.handleConfirmRevoke(true)} color="primary">
                            Create New
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={confirmConvertDialogOpen}
                    onClose={this.handleConfirmConvertClose}
                >
                    <DialogTitle>Convert Potential Listing</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            A potential listing for SKU "{convertListing?.sku}" already exists. Do you want to convert it into a closed listing?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmConvertClose} color="grey">
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirmConvert} color="success">
                            Convert
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

const col_mapper = {
    'Status': 'status',
    'SKU': 'sku',
    'Product Name': 'akeneo_product_name',
    'Listing Date': 'listing_date',
    'Delisting Date': 'delisting_date',
    'EK': 'bc_ek',
    'Margin KoRo': 'margin_koro',
    'VK': 'vk',
    'Margin Retail': 'margin_retail',
    'UVP': 'uvp',
    'POS': 'pos',
    'Tray SKU': 'tray',
    'Tray VK': 'tray_vk',
    'Tax': 'bc_tax',
    'Category': 'akeneo_product_category',
    'RLZ': 'shelf_life',
};

const edit_cols = ['Status', 'UVP', 'POS', 'RLZ', 'Listing Date', 'Delisting Date'];
const sticky_cols = ['Status', 'SKU'];

export default Listings;
